export const PICKER = "/picker";

export const getAllPickers = `${PICKER}/getAllPickers`;

export const getPickerById = `${PICKER}/getPickerById/:pickerId`;

export const createPicker = `${PICKER}/createPicker`;

export const editPicker = `${PICKER}/editPicker/:pickerId`;

export const pickerLogin = `${PICKER}/login`;
